import React, { Component } from "react";
import Select from 'react-select';
import DropdownStyle from "../styles/dropdown.style.js";

import { IconChevron } from "../icons";

import Styles from "./plot.module.scss";

class Plot extends Component {

    constructor(props) {
        super(props);
        const expandable = Boolean(props.breakdown)
        this.state = {
            isExpanded: false,
            expandable,
            selectedBreakdown: expandable ? {
                label: props.breakdown[0].breakdownKey,
                value: props.breakdown[0],
            } : null,
        }
    }

    renderVis() {
        const { plotData, dataScale, datumWidth, timeScale } = this.props;
        const rects = plotData.map((datum, index) => {
            return (
                <rect
                    key={index}
                    className={Styles.visRect}
                    x={timeScale(datum.timestamp) + "%"}
                    width={datumWidth + "%"}
                    y={0}
                    height={"100%"}
                    style={{
                        opacity: dataScale(datum.value),
                        fill: this.props.color,
                    }}
                />
            )
        })
        return (
            <svg className={Styles.vis}>
                {rects}
            </svg>
        )
    }

    renderExpanded() {
        const { isExpanded, selectedBreakdown } = this.state;
        if (!isExpanded) return null;
        
        const options = this.props.breakdown.map(breakdown => {
            return {
                label: breakdown.breakdownKey,
                value: breakdown,
            }
        })

        const plotTotal = selectedBreakdown.value.items.reduce((acc, n) => acc + n.value, 0); 

        const breakdownPlots = selectedBreakdown.value.items.map(breakdownItem => {
            const pct = (breakdownItem.value / plotTotal) * 100;
            return (
                <div className={Styles.breakdownItem} key={breakdownItem.label}>
                    <div className={Styles.breakdownStat}>
                        <span className={Styles.breakdownStatLabel}>{breakdownItem.label}</span>
                        <span className={Styles.breakdownStatValue}>{breakdownItem.value}</span>
                    </div>
                    <div className={Styles.breakdownPlot}>
                        <div 
                            className={Styles.breakdownPlotFill}
                            style={{
                                width: pct + "%",
                            }}
                        />
                        <div
                            className={Styles.breakdownPlotPercent}
                            data-big={pct > 92}
                            style={{
                            left: pct + "%",  
                            }}
                        >
                            {pct.toFixed(1)} %
                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div className={Styles.expanded}>
                <h4>Breakdown</h4>
                <Select
                    options={options}
                    value={selectedBreakdown}
                    onChange={v => this.setState({ selectedBreakdown: v })}
                    styles={DropdownStyle}
                    className={Styles.breakdownDropdown}
                    isSearchable={false}
                />
                {breakdownPlots}
            </div>
        )
    }

    // TODO: better place? selector?
    findCurrentFrameData() {
        const { plotData, currentTimestamp } = this.props;
        return plotData.find(
            frame =>
                currentTimestamp >= frame.timeExtents[0] &&
                currentTimestamp < frame.timeExtents[1]
        );
    }

    renderStatsItems() {
        const currentFrame = this.findCurrentFrameData();
        return (
            <div className={Styles.statsSection}>
                <div className={Styles.statsItem}>
                    {currentFrame ? currentFrame.value : 0}
                </div>
                <div className={Styles.statsItem}>
                    {this.props.total}
                </div>
            </div>
        )
    }

    render() {
        const { expandable, isExpanded } = this.state;
        return (
            <div className={Styles.plotOuter}>
                <div className={Styles.plot}>
                    <div className={Styles.plotDetails}>
                        <div className={Styles.expandArrowContainer}>
                            <button
                                className={Styles.expandArrow}
                                data-visible={expandable}
                                data-expanded={isExpanded}
                                onClick={() => this.setState({isExpanded: !isExpanded})}
                            >
                                <IconChevron />
                            </button>
                            <div
                                className={Styles.plotIcon}
                                style={{
                                    backgroundColor: this.props.color,
                                }}
                            />
                        </div>
                        <h4 className={Styles.nameLabel}>{this.props.plotKey}</h4>
                        {this.renderStatsItems()}
                    </div>
                    {this.renderVis()}
                </div>
                {this.renderExpanded()}
            </div>
        );
    }
}

export default Plot;



// WEBPACK FOOTER //
// ./src/components/plot/plot.js